<template>
  <div class="clearfix company-form-container rounded mt-4 pb-5 mx-auto pl-3 pr-3">

    <div class="d-flex justify-content-start">
      <b-form-group id="status-group" label-for="status">
        <b-form-checkbox id="status" v-model="status" name="status" :value="1" :unchecked-value="0">
          Disable Mail Sending
        </b-form-checkbox>
      </b-form-group>
    </div>
    <b-button @click="changeMailStatus">Save</b-button>

  </div>
</template>


<script>
export default{
  data(){

    return {
      errormsg:[],
      saved_name : '',
      showoverlay:false,
      showoverlay_list:false,
      successmsg:false,
      warningmsg:false,
      dangermsg:false,
      status:0,
    }
  },
  methods:{

    getMailStatus(){
      axios.get(this.$api_url + '/la/mail/status').then(response => {
        this.status = response.data;
      });
    },

    changeMailStatus(){
      let formData = new FormData();
      formData.append('status', this.status)

      axios.post(this.$api_url + '/la/mail/status', formData).then(response => {
        this.getMailStatus();
        this.$bvToast.toast(response.data.message,{
          variant: 'success',
          title: 'Success',
          solid: true,
        });
      });
    },

  },
  created: function(){
    this.getMailStatus();
  },
}
</script>
